module.exports = __webpack_public_path__ + "static/media/remove-icon.370c64bd.svg";